import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

export const productAccessorHasPersonalCompleteAttribute = (
  product: PimProductWithVariantsV1,
): boolean => {
  for (const variant of product.variants) {
    // eslint-disable-next-line unicorn/iteration-fallback-style,unicorn/no-unreadable-for-of-expression -- don't reference, refactor if touched
    for (const attribute of variant.variant_attributes ?? []) {
      if (attribute.personal && attribute.complete) {
        return true
      }
    }
  }

  return false
}
